import { Box, CircularProgress, IconButton } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import type { MouseEvent, ReactElement } from 'react';

interface SelectedImageCardProps {
  thumbnailUrl: string;
  alt?: string;
  isPending: boolean;
  onReplaceClick: (event: MouseEvent<HTMLButtonElement>) => void;
  onDelete: () => void;
}

export function SelectedImageCard({
  thumbnailUrl,
  alt,
  isPending,
  onReplaceClick,
  onDelete,
}: SelectedImageCardProps): ReactElement {
  return (
    <Box className="vtwo:flex vtwo:items-center vtwo:gap-2 vtwo:px-4 vtwo:py-2 vtwo:rounded-xl vtwo:border-2 vtwo:border-plus-border vtwo:bg-white">
      <Box className="vtwo:w-16 vtwo:h-16 vtwo:rounded-lg vtwo:overflow-hidden vtwo:shrink-0 vtwo:bg-gray-100">
        {thumbnailUrl && (
          <img
            src={thumbnailUrl}
            alt={alt ?? ''}
            className="vtwo:w-full vtwo:h-full vtwo:object-cover"
          />
        )}
      </Box>
      <Box className="vtwo:ml-auto vtwo:flex vtwo:items-center vtwo:gap-1">
        <IconButton size="small" disabled={isPending} onClick={onReplaceClick}>
          {isPending ? <CircularProgress size={16} /> : <SwapHorizIcon fontSize="small" />}
        </IconButton>
        <IconButton size="small" disabled={isPending} onClick={onDelete}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
